'use client';
import React from 'react';
import Image from 'next/image';
import "./Testimonial.css";
import OwlSlider from '@/components/OwlSlider';

const testimonials = [
    {
        name: "Pratyush Swaraj",
        title: "Modern Facilities",
        description: "Outstanding care, skilled staff, modern facilities, exceptional service and clean environment.👍🏽",
        readmore: "https://maps.app.goo.gl/Fr5C3SwusvvCY3CH7",
        time: "4 months ago"
    },
    {
        name: "Anchit sharma",
        title: "Very Good Facilities",
        description: "Excellent healthcare facilities in the leadership of Dr. Nishant Tripathy sir. The team is fabulous...",
        readmore: "https://maps.app.goo.gl/MrjuARMh6cuRGa2i6",
        time: "8 months ago"
    },
    {
        name: "Farhat Aafrin",
        title: "Good Behaviour",
        description: "I went to this hospital in very emergency to meet dr harshwardhan about my kidney...",
        readmore: "https://maps.app.goo.gl/tSSQuxBdbUny9YB98",
        time: "8 months ago"
    },
    {
        name: "Nirajan Sharma",
        title: "Good Services",
        description: "#Dr.Nishant Tripathi Best cardiologist.....his behavior is also so cooperative ...any one can get ...expected treatment",
        readmore: "https://maps.app.goo.gl/2Gj1pjmXiMLnSxeQ6",
        time: "a month ago"
    }
];

const Testimonials = () => {
    return (
        <div>
            <section className='Healthy-patient css-padding'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='title-section text-centre'>
                                <p className='css-heading'>
                                    <span className='first-title'>Our</span>
                                    <span className='second-title'> Healthy </span>
                                    <span className='first-title'>Patient</span>
                                </p>
                                <Image
                                    src="/images/DNA.webp"
                                    alt="DNA image"
                                    width={67}
                                    height={21}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='row mt-4'>
                        <OwlSlider
                            items={[...testimonials, ...testimonials].map((item, index) => (
                                <div className='testimonial-card text-center mx-2' key={index}>
                                    <div className='d-flex justify-content-between align-items-start mb-2'>
                                        <Image
                                        src="https://cdn.dotplus.in/Cloud/Aarogyam/home/aarogyamtestimonials/google-img.png?width=136"
                                        alt="Google"
                                        width={136}
                                        height={46}
                                        />
                                        <div className='user-img-css'>
                                            <Image
                                                src='https://cdn.dotplus.in/Cloud/Aarogyam/home/aarogyamtestimonials/user.jpg'
                                                alt={item.name}
                                                width={52}
                                                height={52}
                                            />
                                        </div>
                                    </div>
                                    <p className='css-patient-name'>{item.name}</p>
                                    <div className='text-warning mb-1'>
                                        {[...Array(5)].map((_, i) => (
                                            <i className='fa fa-star' key={i}></i>
                                        ))}
                                    </div>
                                    <p className='css-patient-title fw-bold text-dark'>“{item.title}”</p>
                                    <p className='css-patient-description'>{item.description}</p>
                                    <a href={item.readmore} className='css-read-more' target='_blank' rel='noopener noreferrer'> Read more...</a>
                                    <p className='css-month-ago small d-flex justify-content-center align-items-center gap-1'>
                                        <Image
                                            src='https://cdn.dotplus.in/Cloud/Aarogyam/home/aarogyamtestimonials/google-logo-png-webinar.png'
                                            alt='Google Logo'
                                            width={20}
                                            height={20}
                                            style={{ objectFit: 'contain' }}
                                        />
                                        {item.time}
                                    </p>
                                </div>
                            ))}
                            itemsPerView={{
                                0: 1,
                                576: 1,
                                768: 2,
                                992: 3,
                                1200: 4,
                            }}
                            autoplay={true}
                            autoplayInterval={6000}
                            nav={true}
                        />
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Testimonials;
